import PageHeader from "@/components/PageHeader";
import CollectionToolbar from "@/components/collection/CollectionToolbar";
import CollectionGrid from "@/components/collection/CollectionGrid";
import { useCollection } from "@/lib/useCollection";
import { media } from "@/data/media";
import { images } from "@/data/images";

export default function Media() {
  const collection = useCollection(media, {
    pageSize: 6,
    searchKeys: ["title", "excerpt", "category", "type"],
  });

  return (
    <div data-testid="media-page">
      <PageHeader
        eyebrow="Media"
        title="Podcast, video & film."
        intro="Conversations on the craft of coaching and visual breakdowns of skill and strategy. New episodes and videos added over time."
        image={images.dunkDark}
      />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <CollectionToolbar
            collection={collection}
            searchPlaceholder="Search episodes & videos..."
            testidPrefix="media"
          />
          <div className="mt-4">
            <CollectionGrid
              collection={collection}
              testidPrefix="media"
              emptyLabel="No media matches your search yet."
            />
          </div>
        </div>
      </section>
    </div>
  );
}
